<template>
  <div>
    <p class="text">{{ $t('IMPORTING_REPOSITORY') }}</p>
    <loader></loader>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Loader from '@/components/Loader.vue';

export default {
  components: {
    Loader,
  },
  computed: {
    title() {
      return this.$t('IMPORTING_REPOSITORY');
    },
    ...mapState(['configLoaded']),
    ...mapGetters(['isDeviceLinked']),
    url() {
      return decodeURIComponent(this.$route.query.url);
    },
    isDeviceNotLinked() {
      return this.configLoaded && !this.isDeviceLinked;
    },
  },
  watch: {
    isDeviceNotLinked: {
      immediate: true,
      handler(newValue) {
        if (!newValue) {
          return;
        }

        this.$router.replace({
          name: 'error',
          params: {
            message: 'NO_DEVICE_LINKED',
            link: '/link',
            linkText: this.$t('GO_TO_LINK_PAGE'),
          },
        });
      },
    },
  },
  methods: {
    validateURL() {
      try {
        // eslint-disable-next-line no-new
        new URL(this.url);
        return true;
      } catch {
        this.$router.replace({
          name: 'error',
          params: {
            message: 'PROVIDE_VALID_URL',
            link: '/my/repos',
            linkText: 'MY_REPOSITORIES',
          },
        });
        return false;
      }
    },
    import() {
      this.$api.addRepo(this.url)
        .then((response) => {
          if (!response.success) {
            throw response;
          }

          this.$router.replace(`/repos/${response.data.id}`);
        })
        .catch((response) => {
          this.$router.replace({
            name: 'error',
            params: {
              message: response.errors[0].translated,
              link: '/my/repos',
              linkText: 'MY_REPOSITORIES',
            },
          });
        });
    },
  },
  created() {
    if (this.validateURL()) {
      this.import();
    }
  },
};
</script>

<style lang="scss" scoped>
.text {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
  padding: 0 15px;
  line-height: 24px;
}
</style>
